import { render, staticRenderFns } from "./SingPie.vue?vue&type=template&id=4f58c344&scoped=true"
import script from "./SingPie.vue?vue&type=script&lang=js"
export * from "./SingPie.vue?vue&type=script&lang=js"
import style0 from "./SingPie.vue?vue&type=style&index=0&id=4f58c344&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f58c344",
  null
  
)

export default component.exports